import React, {FC} from 'react'
import {
  PaymentBookCardContainer,
  PaymentCardImg,
  PaymentCardTitle,
  PaymentCircle,
  PaymentCircleInner,
  PaymentGap
} from './style'



/**
 * SinglePaymentMethod component
 * @param img The image source for the payment method
 * @param id The id of the payment method
 * @param cardInfo The information to display for the payment method
 * @param isSelect Whether the payment method is selected
 * @param onClick Function to set the selected payment method
 * @returns {Element}
 * @constructor
 */
const SinglePaymentMethod = ({ img, id, cardInfo, isSelect, onClick }) => {

    return (
        <PaymentBookCardContainer onClick={() => onClick(id)}>
            <PaymentGap container alignItems='center'>
                <PaymentCardImg src={img} alt="Payment Card" />
                <PaymentCardTitle>{cardInfo}</PaymentCardTitle>
            </PaymentGap>
            <PaymentCircle>
                {isSelect && <PaymentCircleInner />}
            </PaymentCircle>
        </PaymentBookCardContainer>
    )
}

export default SinglePaymentMethod;
